import React from "react";
import { Box } from "@theme-ui/components";

interface Props {
  onClickaway: (e: any) => any;
}

export const CloseOnClickaway: React.FC<Props> = ({
  children,
  onClickaway,
}) => {
  const node = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    const handleClick = (e: any) => {
      if (node?.current?.contains(e.target)) {
        return;
      }
      onClickaway(e);
    };
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [onClickaway]);

  return (
    <Box sx={{ width: "100%" }} ref={node}>
      {children}
    </Box>
  );
};
